import { render, staticRenderFns } from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=template&id=a6fb1ab0&scoped=true&"
import script from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeTreasuriesTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fb1ab0",
  null
  
)

export default component.exports